import { useRef } from 'react';
import { useActiveBundle } from '@/context/active-bundle';
import { AppBundle } from '@/utils/app-bundles';

import { AppLayoutNav, Box, SideNav, useSideNavState } from '@customerio/pluma-components/react';
import { shouldShowDevHelper } from '@/services/dev-helper/store';
import { DevToolsNavButton } from './dev-tools-nav-button';
import { PlanNavCta } from './plan-nav-cta';
import './wrapper.css';

type MainNavigationWrapperProps = {
  children?: React.ReactNode;
};

export function MainNavigationWrapper({ children }: MainNavigationWrapperProps) {
  const activeApp = useActiveBundle();
  const sideNavRef = useRef<HTMLElement>(null);
  const isCollapsible = useSideNavState()?.isCollapsible !== false;

  return (
    <AppLayoutNav>
      <SideNav
        ref={sideNavRef}
        overflowY="auto"
        overflowX="hidden"
        aria-label="Main"
        style={{ scrollbarWidth: 'thin' }}
        pt="0"
      >
        {children}

        <Box mt="auto">
          <PlanNavCta />
          {Object.values(AppBundle).map((bundle) => (
            <div
              key={bundle}
              id={`hydra-main-nav-footer-portal-${bundle}`}
              style={activeApp !== bundle ? { display: 'none' } : {}}
            />
          ))}
          {shouldShowDevHelper() ? <DevToolsNavButton sideNavRef={sideNavRef} isCollapsible={isCollapsible} /> : null}
        </Box>
      </SideNav>
    </AppLayoutNav>
  );
}
